/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import * as l10n from './VirtualServicePolicyHeaderController.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @ngdoc controller
 * @name VirtualServicePolicyHeaderController
 */
class VirtualServicePolicyHeaderController {
    constructor($scope, l10nService) {
        $scope.l10nKeys = l10nKeys;
        l10nService.registerSourceBundles(dictionary);
    }
}

VirtualServicePolicyHeaderController.$inject = [
    '$scope',
    'l10nService',
];

angular.module('aviApp').controller('VirtualServicePolicyHeaderController',
    VirtualServicePolicyHeaderController);
